/**
 * WHICH PRODUCT SCREEN an add-on row sells on.
 *
 * `css_name` is the RENDERER -- which case in Item.jsx draws the product and
 * where the pose sits on its artwork. `product_key` is the PRODUCT. They are
 * usually the same string, and deliberately so: a blank column falls back to
 * css_name server-side (Addon#product_key), so every row that has never been
 * split groups exactly as it always did.
 *
 * Rows sharing a key share ONE screen, listed as a quantity stepper each --
 * that is how "(8)/(16)/(24)/(48) Wallets" are one product with four choices.
 * Rows sharing only a css_name are DIFFERENT products drawn the same way: the
 * neutral and school-theme weekly dry-erase magnets both place the pose at the
 * same spot on their boards, and before this split they collapsed onto one
 * screen under whichever sorted first.
 *
 * ⚠️ THE FALLBACK IS FOR THE ROLLOUT, not for missing data. The API always
 * serves `productKey`, but ECS runs old and new containers side by side during
 * a deploy, so a freshly loaded bundle can be served by a container that does
 * not know the attribute yet. Without this, every tile in that window would set
 * `?product=undefined` and open nothing at all. Reading through one function
 * means that window behaves exactly like today instead.
 */
export default function productKeyOf(addon) {
  return addon?.productKey || addon?.cssName || '';
}
